import type React from 'react';

import { useGetResources } from '@hooks/useGetResources';

import Icon from '@helsenorge/designsystem-react/components/Icon';
import Shield from '@helsenorge/designsystem-react/components/Icons/Shield';

interface Props {
  extraClass?: string;
}

const AssuranceElement = ({ extraClass }: Props): React.JSX.Element => {
  const resources = useGetResources();
  return (
    <div className={`verktoy__assuranceContainer ${extraClass ? extraClass : ''}`}>
      <Icon svgIcon={Shield} size={32}></Icon>
      <p className="verktoy__assuranceText">{resources?.entryPage_personvern}</p>
    </div>
  );
};
export default AssuranceElement;
